import { render, staticRenderFns } from "./second.vue?vue&type=template&id=ec1c7e56&"
import script from "./second.vue?vue&type=script&lang=js&"
export * from "./second.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports